import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/MailDeliveryGame/scenes/GameIntro';

interface PhaserDinerGameProps {
    onComplete: () => void;

}

interface PhaserDinerGameState {
}

const templateConfig: GameConfig = {
    title: "Mail Delivery Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserMailDeliveryGame extends React.Component<PhaserDinerGameProps, PhaserDinerGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserDinerGameProps) {
        super(props);
        bindAllOfThis(this, PhaserMailDeliveryGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={templateConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserMailDeliveryGame;



// WEBPACK FOOTER //
// ./src/games/MailDeliveryGame/Main.tsx